import { render, staticRenderFns } from "./navigator.vue?vue&type=template&id=2cef8ffc&"
import script from "./navigator.vue?vue&type=script&lang=js&"
export * from "./navigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports